import { Badge } from '@yeshuman/sdk'
import { AlertCircle, CheckCircle2, Clock, FileWarning } from 'lucide-react'
import { ClassificationStatus, HealthRecordType } from '../hooks/use-health-records'

export const TYPE_LABELS: Record<HealthRecordType, string> = {
  general_document: 'Document',
  test_result: 'Test result',
  imaging: 'Imaging',
  referral: 'Referral',
  prescription: 'Prescription',
  form: 'Form',
  correspondence: 'Correspondence',
  receipt_or_invoice: 'Receipt or invoice',
  unknown: 'Unclassified',
}

export const STATUS_LABELS: Record<ClassificationStatus, string> = {
  pending: 'Pending',
  processing: 'Processing',
  classified: 'Classified',
  needs_review: 'Needs review',
  unsupported: 'Unsupported',
  failed: 'Failed',
}

export const SOURCE_LABELS: Record<string, string> = {
  user_upload: 'User upload',
  records_upload: 'Records upload',
  composer: 'Composer',
  agent: 'Agent',
  email: 'Email',
}

export function formatRecordDate(value?: string | null) {
  if (!value) return 'No date recorded'
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(new Date(value))
}

export function formatDateTime(value?: string | null) {
  if (!value) return 'Not recorded'
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value))
}

export function formatPercent(value?: number | null) {
  if (typeof value !== 'number') return 'Not recorded'
  return `${Math.round(value * 100)}%`
}

export function statusVariant(status: ClassificationStatus): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (status === 'classified') return 'secondary'
  if (status === 'failed') return 'destructive'
  if (status === 'unsupported' || status === 'needs_review') return 'outline'
  return 'secondary'
}

export function StatusBadge({ status }: { status: ClassificationStatus }) {
  const Icon = status === 'classified' ? CheckCircle2 : status === 'failed' || status === 'unsupported' ? FileWarning : status === 'needs_review' ? AlertCircle : Clock

  return (
    <Badge variant={statusVariant(status)} className="gap-1">
      <Icon className="h-3.5 w-3.5" />
      {STATUS_LABELS[status]}
    </Badge>
  )
}
